export interface StaffData {
    id: string;
    data: string;
    oreColazione: number;
    orePranzo: number;
    oreCena: number;
    totProd: number;
    colazioneProd: number;
    pranzoProd: number;
    cenaProd: number;
    totCol: number;
    colazioneCol: number;
    pranzoCol: number;
    cenaCol: number;
    totColPer: number;
    colazioneColPer: number;
    pranzoColPer: number;
    cenaColPer: number;
}

export class StaffBi {
    oreLavorate!: string;
    costoProduzione!: string;
    costoCol!: string;
    costoColPercentuale!: string;
    staffData!: StaffData[];

    static fromJson(json: any): StaffBi {
        let result = new StaffBi();
        result.oreLavorate = json.oreLavorate;
        result.costoProduzione = json.costoProduzione;
        result.costoCol = json.costoCol;
        result.costoColPercentuale = json.costoColPercentuale;
        result.staffData = json.staffData || [];
        return result;
    }
}